import { createBrowserRouter, Navigate } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import AuthLayout from "../layout/AuthLayout";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import ErrorUI from "../pages/Error/ErrorUI";
import NotFound from "../pages/Error/NotFound";
import Login from "../pages/Login/Login";
import ManageUsers from "../pages/UserRoleMngt/ManageUsers/ManageUsers";
import UserDetails from "../pages/UserRoleMngt/ManageUsers/UserDetails";
import ManageRm from "../pages/UserRoleMngt/ManageRm/ManageRm";
import InvoiceUpload from "../pages/InvoiceUpload/InvoiceUpload";
import SupplyChainUpload from "../pages/SupplyChainUpload/SupplyChainUpload";
import DealsUpload from "../pages/DealsUpload/DealsUpload";
import UploadFiles from "../pages/InvoiceUpload/Components/UploadFiles";
import SupplyChainUploadFiles from "../pages/SupplyChainUpload/Components/UploadFiles";
import Deals from "../pages/Deals/Deals";
import DealDetailView from "../pages/Deals/DealDetailView";
import JointVenturesDeals from "../pages/JointVenturesDeals/JointVenturesDeals";
import DealsManagement from "../pages/DealsManagement/DealsManagement";
import Settlements from "../pages/Settlements/Settlements";
import Wallets from "../pages/Wallets/Wallets";
import Reports from "../pages/Reports/Reports";
import EnqMngt from "../pages/EnqMngt/EnqMngt";
import Business from "../pages/Business/Business";
import Investor from "../pages/Investor/Investor";
import Enterprise from "../pages/Enterprise/Enterprise";
import CreditLimit from "../pages/CreditLimit/CreditLimit";
import Payments from "../pages/Payments/Payments";
import RmDetails from "../pages/UserRoleMngt/ManageRm/RmDetails";
import CompleteKyc from "../pages/EnqMngt/CompleteKyc";
import ReviewKyc from "../pages/EnqMngt/ReviewKyc";
import SendQuestionnaire from "../pages/EnqMngt/SendQuestionnaire";
import SendQuestionnaireForm from "../pages/EnqMngt/SendQuestionnaireForm";
import ViewBusinessDetails from "../pages/EnqMngt/ViewBusinessDetails";
import EntDetails from "../pages/Enterprise/EntDetails";
import BusDetails from "../pages/Business/BusDetails";
import InvDetails from "../pages/Investor/InvDetails";
import ManualKycReviewScreen from "../pages/Investor/ManualKycReviewScreen";
import BusEntDetails from "../pages/CreditLimit/BusEntDetailedView";
import AssignDeal from "../pages/Deals/AssignDeal";
import PaymentDetails from "../pages/Payments/PaymentDetails";
import DisputeDetails from "../pages/Payments/DisputeDetails";
import WalletDetails from "../pages/Wallets/WalletDetails";
import SettlementDetails from "../pages/Settlements/SettlementDetails";
import ChangePassword from "../pages/Login/ChangePassword";
import ForgotPassword from "../pages/Login/ForgotPassword";
import Otp from "../pages/Login/Otp";
import ResetPassword from "../pages/Login/ResetPassword";
import Unauthorized from "../pages/Error/Unauthorized";
import PrivilegedRoute from "./PrivilegedRoute";
import { PERM_CODE, QUESTIONNAIRE_ROUTE_PERMS } from "../constants/PermissionCodes";
import MasterData from "../pages/MasterData/MasterData";
import Notifications from "../pages/Notifications/Notifications";
import QuestionBank from "../pages/QuestionBank/QuestionBank";
import QuestionnaireThread from "../pages/EnqMngt/QuestionnaireThread";
import ReviewAllThreads from "../pages/EnqMngt/ReviewAllThreads";
import JointVentures from "../pages/JointVentures/JointVentures";
import DealApproval from "../pages/DealApproval/DealApproval";
import JointVenturesViewDetails from "../pages/JointVenturesViewDetails/JointVenturesViewDetails";
import BankOperations from "../pages/BankOperations/BankOperations";
import Details from "../pages/EnqMngt/Details"
const privileged = (accessCode, Component) => (
    <PrivilegedRoute accessCode={accessCode}>
        {Component}
    </PrivilegedRoute>
);

const router = createBrowserRouter(
    [
        {
            path: "/",
            element: <Navigate to="login" />,
        },
        {
            path: "/",
            element: (
                <ProtectedRoute>
                    <DashboardLayout />
                </ProtectedRoute>
            ),
            errorElement: <ErrorUI />,
            children: [
                {
                    path: "user-role-management",
                    children: [
                        { path: "manage-users", element: privileged(PERM_CODE.URACC, <ManageUsers />) },
                        { path: "manage-users/user-details", element: privileged(PERM_CODE.URACC, <UserDetails />) },
                        { path: "manage-rm", element: privileged(PERM_CODE.URACC, <ManageRm />) },
                        { path: "manage-rm/rm-details", element: privileged(PERM_CODE.URACC, <RmDetails />) },
                    ],
                },
                {
                    path: "MasterData",
                    element: privileged(PERM_CODE.URACC, <MasterData />)
                },
                {
                    path: "question-bank",
                    element: privileged(PERM_CODE.URACC, <QuestionBank />)
                },

                {
                    path: "enquiry-management",
                    children: [
                        { index: true, element: privileged(PERM_CODE.EMACC, <EnqMngt />) },
                        { path: "complete-kyc/:orgId", element: privileged(PERM_CODE.EMACC, <CompleteKyc />) },
                        { path: "review-kyc/:orgId", element: privileged(PERM_CODE.EMACC, <ReviewKyc />) },
                        { path: "send-questionnaire/:orgId", element: privileged(QUESTIONNAIRE_ROUTE_PERMS, <SendQuestionnaire />) },
                        { path: "send-questionnaire-form/:orgId", element: privileged(QUESTIONNAIRE_ROUTE_PERMS, <SendQuestionnaireForm />) },
                        { path: "view-thread/:orgId/:threadId", element: privileged(QUESTIONNAIRE_ROUTE_PERMS, <QuestionnaireThread />) },
                        { path: "review-stage/:orgId", element: privileged(QUESTIONNAIRE_ROUTE_PERMS, <ReviewAllThreads />) },
                        { path: "view-business/:orgId", element: privileged(PERM_CODE.EMACC, <ViewBusinessDetails />) },
                        { path: "enq-details/:orgId", element: <Details />},
                    ],
                },
                {
                    path: "business",
                    children: [
                        { index: true, element: privileged(PERM_CODE.BUACC, <Business />) },
                        { path: "bus-details/:orgId/:status", element: privileged(PERM_CODE.BUACC, <BusDetails />) },
                    ],
                },
                {
                    path: "investor",
                    children: [
                        { index: true, element: privileged(PERM_CODE.IVACC, <Investor />) },
                        { path: "inv-details/:orgId/:status", element: privileged(PERM_CODE.IVACC, <InvDetails />) },
                        { path: "review-manual-kyc/:orgId", element: privileged(PERM_CODE.IVACC, <ManualKycReviewScreen />) },
                    ],
                },
                {
                    path: "enterprise",
                    children: [
                        { index: true, element: privileged(PERM_CODE.ENACC, <Enterprise />) },
                        { path: "ent-details/:entId/:status", element: privileged(PERM_CODE.ENACC, <EntDetails />) },
                    ],
                },
                {
                    path: "credit-limit",
                    children: [
                        { index: true, element: privileged(PERM_CODE.CLACC, <CreditLimit />) },
                        {
                            path: "BusEnt-details/:busEntId/:status",
                            element: privileged(PERM_CODE.CLACC, <BusEntDetails />),
                        },
                    ],
                },
                {
                    path: "invoice-upload",
                    children: [
                        { index: true, element: privileged(PERM_CODE.IUACC, <InvoiceUpload />) },
                        {
                            path: "upload-inv-files",
                            element: privileged(PERM_CODE.IUACC, <UploadFiles />),
                        },
                    ],
                },
                {
                    path: "supply-chain-upload",
                    children: [
                        { index: true, element: privileged(PERM_CODE.IUACC, <SupplyChainUpload />) },
                        {
                            path: "upload-inv-files",
                            element: privileged(PERM_CODE.IUACC, <SupplyChainUploadFiles />),
                        },
                    ],
                },
                {
                    path: "deals-upload",
                    children: [
                        { index: true, element: privileged(PERM_CODE.IUACC, <DealsUpload />) },
                        {
                            path: "upload-inv-files",
                            element: privileged(PERM_CODE.IUACC, <UploadFiles />),
                        },
                    ],
                },
                {
                    path: "deal-approval",
                    element: privileged(PERM_CODE.JVACC, <DealApproval />),

                },
                {
                    path: "joint-ventures-view-details",
                    element: privileged(PERM_CODE.DLACC, <JointVenturesViewDetails />),
                },
                {
                    path: "deals-management",
                    element: privileged(PERM_CODE.DLACC, <DealsManagement />),
                },
                {
                    path: "joint-ventures-deals",
                    element: privileged(PERM_CODE.DMACC, <JointVenturesDeals />),
                },
                {
                    path: "joint-ventures",
                    children: [
                        { index: true, element: privileged(PERM_CODE.JVACC, <JointVentures />) },
                        {
                            path: "upload-inv-files",
                            element: privileged(PERM_CODE.JVACC, <UploadFiles />),
                        },
                    ],
                },
                {
                    path: "deals",
                    children: [
                        { index: true, element: privileged(PERM_CODE.DLACC, <Deals />) },
                        {
                            path: "approve-deal/:dealId",
                            element: privileged(PERM_CODE.DLACC, <AssignDeal />),
                        },
                        {
                            path: "deal-details",
                            element: privileged(PERM_CODE.DLACC, <DealDetailView />),
                        },
                    ],
                },
                {
                    path: "settlements",
                    children: [
                        { index: true, element: privileged(PERM_CODE.SLACC, <Settlements />) },
                        {
                            path: "settlement-details/:txnId",
                            element: privileged(PERM_CODE.SLACC, <SettlementDetails />),
                        },
                    ],
                },
                {
                    path: "payments",
                    children: [
                        { index: true, element: privileged(PERM_CODE.PYACC, <Payments />) },
                        {
                            path: "payment-details/:txnId/:tabIndex",
                            element: privileged(PERM_CODE.PYACC, <PaymentDetails />),
                        },
                        {
                            path: "payment-details/:txnId/dispute-details/:disputeId",
                            element: privileged(PERM_CODE.PYACC, <DisputeDetails />),
                        },
                    ],
                },
                {
                    path: "bank-operations",
                    element: privileged(PERM_CODE.PYACC, <BankOperations />),
                },
                {
                    path: "reports",
                    element: privileged(PERM_CODE.RTACC, <Reports />),
                },
                {
                    path: "wallets",
                    children: [
                        { index: true, element: privileged(PERM_CODE.WLACC, <Wallets />) },
                        { path: "wallet-detail", element: privileged(PERM_CODE.WLACC, <WalletDetails />) },
                    ],
                },
                {
                    path: "change-password",
                    element: <ChangePassword />,
                },
                {
                    path: "notifications",
                    element: <Notifications />,
                },
            ],
        },
        {
            path: "/",
            element: (
                <PublicRoute>
                    <AuthLayout />
                </PublicRoute>
            ),
            errorElement: <ErrorUI />,
            children: [
                { path: "login", element: <Login /> },
                { path: "forgot-password", element: <ForgotPassword /> },
                { path: "otp", element: <Otp /> },
                { path: "reset-password", element: <ResetPassword /> },
            ],
        },
        {
            path: "/complete-kyc",
            element: <CompleteKyc />,
            errorElement: <ErrorUI />,
        },
        {
            path: "unauthorized",
            element: <Unauthorized />,
        },
        {
            path: "*",
            element: <NotFound />,
        },
    ],
    {
        future: {
            v7_fetcherPersist: true,
            v7_normalizeFormMethod: true,
            v7_partialHydration: true,
            v7_relativeSplatPath: true,
            v7_skipActionErrorRevalidation: true,
            v7_startTransition: true,
        },
    }
);

export default router;
